import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { tap } from 'rxjs';
import { APP_CONFIG } from '../../configurations/configurations.factory';
import { Configurations } from '../../configurations/models/configurations.model';
import { IconConfiguration } from '../../configurations/models/icon-configurations.model';

@Injectable({
  providedIn: 'root'
})
export class IconRegistryService {

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    @Inject(APP_CONFIG) private config: Configurations
  ) { }

  load() {

    //console.log('config', this.config)

    return new Promise(async (resolve, reject) => {

      this.config.iconsConfig.forEach(config => {
        this.matIconRegistry.addSvgIcon(
          config.name,
          this.domSanitizer.bypassSecurityTrustResourceUrl(config.path)
        )
      })

      resolve(null)
    })

  }
}
